import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TuiHintModule, TuiTextfieldControllerModule } from "@taiga-ui/core";
import { TuiInputNumberModule } from "@taiga-ui/kit";
import { KwikUIInputNumberComponent } from "./input-number.component";

@NgModule({
  declarations: [KwikUIInputNumberComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiHintModule,
    TuiInputNumberModule,
    TuiTextfieldControllerModule
  ],
  exports: [KwikUIInputNumberComponent]
})
export class KwikUIInputNumberModule {}
